import {
  TranslationConcretingRequestMessages,
  ConcretingRequestMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingRequestMessages = {
  [ConcretingRequestMessages.stepContractText]: "Contrato",
  [ConcretingRequestMessages.stepConcretingText]: "Hormigonado",
  [ConcretingRequestMessages.stepConcreteRecipeText]: "Receta",
  [ConcretingRequestMessages.stepPumpText]: "Bomba",
  [ConcretingRequestMessages.requestNewConcretingText]:
    "Solicitar novo hormigonado",
  [ConcretingRequestMessages.clientWithPendencyText]:
    "El cliente tiene una pendencia, póngase en contacto con el comercial.",
  [ConcretingRequestMessages.messagesDialogTitle]: "Mensajes",
  [ConcretingRequestMessages.messageUnderReview]:
    "Solicitud de Hormigonado en análisis. Próximamente recibirá confirmación o no de la solicitud.",
  [ConcretingRequestMessages.contractWithPendenciesMessage]:
    "Este contrato tiene pendencias, por favor contacte con el departamento financiero.",
  [ConcretingRequestMessages.inactiveContractMessage]:
    "Este contrato está inactivo, por favor contacte con el departamento financiero."
};
